module.exports = __webpack_public_path__ + "img/catImg.e1e7fc94.png";